<template>
    <div>
        <HeroLayout
            id="insure"
            :enable-login-offset="true"
            display-separator
            :overlay-style-overrides="overlayStyleOverrides"
            :enable-new-hero="true"
            :new-hero-class="heroClass"
        >
            <template #title>
                <span class="title">{{ title }}</span>
            </template>
            <template #overlay-body>
                <h2 class="subtitle">{{ section1.subtitle }}</h2>
                <p class="description">
                    {{ section1.description1 }}
                    <sub class="ml-n1">{{ section1.subscript }}</sub>
                    {{ section1.description2 }}
                </p>
                <b-container>
                    <b-row>
                        <b-col cols="12" md="6" lg="6" class="no-padding">
                            <b-img :src="insureImg" alt="Insurance through CarSaver" fluid></b-img>
                            <p></p>
                        </b-col>
                        <b-col class="no-padding">
                            <h2 class="subtitle">{{ section2.subtitle }}</h2>
                            <p class="description">{{ section2.description }}</p>
                            <h2 class="subtitle">Additional Benefits:</h2>
                            <ul>
                                <div v-for="(benefit, index) in benefits" :key="index">
                                    <li>
                                        <p class="no-bottom-padding description">{{ benefit }}</p>
                                    </li>
                                </div>
                            </ul>
                        </b-col>
                    </b-row>
                    <div class="text-center">
                        <primary-btn class="mt-3 mb-3 w-100 max-width--250" @click.native="getAQuote">
                            {{ buttonText }}
                        </primary-btn>
                        <p class="subtext">
                            {{ subtext }} <a href="tel:888-349-3727">{{ contact }}</a>
                        </p>
                    </div>
                </b-container>
            </template>
        </HeroLayout>
        <b-container fluid class="d-flex justify-content-center no-bottom-padding">
            <p class="disclaimer no-bottom-padding">{{ disclaimers.disclaimer1 }}</p>
        </b-container>
        <b-container fluid class="d-flex justify-content-center">
            <p class="disclaimer no-bottom-padding">{{ disclaimers.disclaimer2 }}</p>
        </b-container>
        <floating-footer>
            <primary-btn @click.native="getAQuote">{{ buttonText }}</primary-btn>
        </floating-footer>
        <get-a-quote-modal></get-a-quote-modal>
    </div>
</template>

<script>
import HeroLayout from "Components/HeroLayout";
import insureImg from "../images/insure.png";
import FloatingFooter from "Components/FloatingFooter";
import GetAQuoteModal from "Modules/Home/components/Home/getAQuoteModal";
import PrimaryBtn from "Components/Buttons/PrimaryBtn";

export default {
    name: "Insure",
    components: {
        PrimaryBtn,
        HeroLayout,
        FloatingFooter,
        GetAQuoteModal,
    },
    data() {
        return {
            overlayStyleOverrides: {
                maxWidth: "800px",
            },
            heroClass: "insure-hero",
            insureImg: insureImg,
            benefits: [
                "Multi-Vehicle discount",
                "12 month rate guarantee",
                "24-Hour Claims Assistance",
                "Convenient payment options",
            ],
            title: "Get Special Discounts on Liberty Mutual Insurance Through CarSaver",
            section1: {
                subtitle: "Why Liberty Mutual?",
                description1: `Liberty Mutual shares a mutual commitment to exceptional service and discounted rates.
                That’s why we’re proud to present a special discount`,
                subscript: `1`,
                description2: ` for CarSaver customers when they switch
                to Liberty Mutual. Switch today and you could save $509 on auto insurance,
                plus enjoy great benefits.`,
            },
            section2: {
                subtitle: "Real Savings + Excellent Service",
                description: `When you choose to insure with Liberty Mutual through CarSaver’s platform,
                you will receive the pricing and service you’ve come to expect.
                Experience hassle-free buying and worry-free driving with CarSaver and Liberty Mutual.`,
            },
            buttonText: "Get a Quote",
            subtext: "or call Liberty Mutual at ",
            contact: "(888) 349-3727",
            disclaimers: {
                disclaimer1: `1 Discount not available in TX. 2 Average annual savings based on countrywide
                survey of new customers from 8/1/15 to 8/1/16 who reported savings from prior premiums when
                they switched to Liberty Mutual. Savings comparison does not apply in MA. 3 Discounts and
                savings are available where state laws and regulations allow, and may vary by state. Certain
                discounts apply to specific coverages only. To the extent permitted by law, applicants are
                individually underwritten; not all applicants may qualify. 4Your rate is guaranteed for one
                full year from your effective date. Rate guarantee may not apply if there is a mid-term change
                in underwriting risk that impacts policy premium.`,
                disclaimer2: `A consumer report from a consumer reporting agency and/or a motor vehicle report
                on all drivers listed on your policy may be obtained where state laws and regulations allow. Liberty
                Mutual Insurance is licensed in all 50 states and the District of Columbia. Coverage provided and
                underwritten by Liberty Mutual Insurance Company and its affiliates, Liberty Mutual Insurance
                Company, 175 Berkeley Street, Boston, MA 02116. ©2017 Liberty Mutual Insurance Company.
                All Rights Reserved.`,
            },
        };
    },
    methods: {
        getAQuote() {
            this.$bvModal.show("get-a-quote");
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    @include media-breakpoint-up("md") {
        padding-left: px2rem(20);
        padding-right: px2rem(20);
    }
}
.subtitle {
    font-size: px2rem(18);
    line-height: 1.3;
    font-weight: bold;
    margin-bottom: px2rem(15);
}
.max-width--250 {
    max-width: 250px;
}
.description {
    font-size: px2rem(16);
    letter-spacing: 0;
    line-height: 1.3;
    margin-bottom: px2rem(20);
}
.no-padding {
    padding-left: 0;
    padding-right: 0;
}
.no-bottom-padding {
    padding-bottom: 0;
    margin-bottom: 0;
}
.subtext {
    font-size: px2rem(14);
}
.disclaimer {
    font-size: px2rem(12);
    line-height: 1.3;
    max-width: 800px;
    font-style: italic;
    margin-top: px2rem(20);
}
</style>
